module.exports = __webpack_public_path__ + "static/header-background.70d45af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-background.png
// module id = 1248
// module chunks = 114276838955818